const loadSwiper = (callback) => {
    if (window.Swiper) {
        callback();
        
    } else {
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
        script.onload = callback;
        document.head.appendChild(script);
    }
}